import { buildMortgageRatesPage } from '../../../util/buildMortgageRatesPage';

// This page is used to render mortgage rates pages for all states and loan types.
// It uses the buildMortgageRatesPage utility to generate the page.
const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildMortgageRatesPage();

export { getStaticProps, getStaticPaths };
export default WrappedPage;
